import React from "react";

import { EntityRefBadge } from "../../components/EntityRef/EntityRefBadge";

// Song Processing binding of the platform entity-ref badge (owner UX
// 2026-07-21). Shows "SP-0834E"; hover reveals the canonical proc_job_ id.
// No copy icon (owner: unlabeled copy-style icons make the action unclear) —
// canonical-id copy lives behind the labeled action in Job Detail's
// Technical Details.

export function JobRef({
  jobId,
  refLabel,
  to,
  onOpen,
  prefix,
  testId,
}: {
  jobId: string | null | undefined;
  /** Collision-safe ref from buildJobRefs; defaults to the standard ref. */
  refLabel?: string;
  /** Route destination — renders the ref as a real link. */
  to?: string;
  /** Programmatic open (modals that must close before navigating). */
  onOpen?: () => void;
  /** Optional leading text, e.g. "Job". */
  prefix?: string;
  testId?: string;
}): React.ReactElement {
  return (
    <EntityRefBadge
      kind="processingJob"
      id={jobId}
      refLabel={refLabel}
      to={to}
      onOpen={onOpen}
      prefix={prefix}
      testId={testId}
    />
  );
}
